<div class="container">
    <div id="br-title" class="principal-title">Publicaciones</div>
    <div class="principal-summary">
        <ng-container *ngIf="t1?.summary">{{t1.summary}}</ng-container>
    </div>
    <br>
    <app-carousel-pubs [data]="dataCarousel"></app-carousel-pubs>
    <br>
    <section style="text-align: justify;">
        Seleccione la publicación de acuerdo al año o temática de su interés.
    </section>
    <br>
    <div class="input-group custom-input-group">
        <input type="text" class="form-control" placeholder="Buscar por título"
            (input)="onSearchChange($event.target.value)">
        <button class="btn btn-primary custom-btn" type="button" (click)="filterByTitle()">
            <i class="fa fa-search"></i>
        </button>
    </div>
    <br>
    <div class="row">
        <div class="col-md-4">
            <div style="border: 1px solid #3b69ae; border-radius: 10px; padding: 30px; overflow: auto; height: auto;">
                <div>
                    <div>
                        <select class="form-control select-custom" (change)="applyOrder($event.target.value)"
                            id="select-order">
                            <option value="0">Ordenar por</option>
                            <option value="1">Título (A-Z)</option>
                            <option value="2">Título (Z-A)</option>
                            <option value="3">Fecha (más recientes)</option>
                            <option value="4">Fecha (más antiguo)</option>
                        </select>
                    </div>
                    <br>
                    <div>
                        <select class="form-control select-custom" (change)="filterByYear($event.target.value)"
                            id="select-year">
                            <option selected class="select-items" value="0">Seleccione año</option>
                            <option class="select-items" *ngFor="let y of years" value="{{y.year}}">
                                {{y.year}}
                            </option>
                        </select>
                    </div>
                    <br>
                    <div class="container">
                        <div *ngFor="let comp of compendio">
                            <div class="mb-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value=""
                                        id="flexCheckDefault{{comp.id}}"
                                        (change)="filterByCompendio($event, comp.id, comp.title)">
                                    <label class="form-check-label" for="flexCheckDefault{{comp.id}}">
                                        {{comp.title}}
                                    </label>
                                </div>
                                <div *ngFor="let cl of classif" class="ml-3" style="margin-bottom: 5px;">
                                    <div *ngIf="cl.obCompendioId === comp.id" class="form-check"
                                        style="margin-left: 20px;">
                                        <input class="form-check-input" type="checkbox" value="" id="cl{{cl.id}}"
                                            (change)="filterByClassif($event, cl.id)">
                                        <label class="form-check-label" for="flexCheckDefault{{cl.id}}"
                                            style="margin-left: 5px;">
                                            {{cl.title}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8">
            <div *ngIf="ResultNoEncontrados==true" class="no-results-message" style="text-align: center;">
                No se encontraron resultados
            </div>
            <div class="row">
                <ng-container *ngFor="let p of filteredPubs">
                    <!-- Verificar si es una publicación con un título de grupo -->
                    <ng-container *ngIf="p.groupTitle">
                        <div class="col-12">
                            <h3 class="title_classif">{{ p.groupTitle }}</h3>
                            <!-- Mostrar el título de la clasificación -->
                            <hr> <!-- Línea horizontal -->
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!p.groupTitle">
                        <!-- Asegurarse de no mostrar el título de la clasificación para los elementos que son solo títulos de grupo -->
                        <div class="col-sm-4 mb-1">
                            <!-- Aplica la clase de margen mb-3 para agregar un espacio de 1rem (16px) en la parte inferior -->
                            <div class="row">
                                <div class="col-12 text-center"> <!-- Centrar el contenido horizontalmente -->
                                    <a class="a-pubs" href="/publicacion/detalle/{{p.id}}">
                                        <div class="p-year">[{{p.publication_date | date:'yyyy'}}]</div>
                                        <div class="mx-auto"> <!-- Centrar el contenido horizontalmente -->
                                            <img class="img-fluid img-pubs" src="{{URL}}{{p.urlimg}}" alt="">
                                        </div>
                                        <div class="py-1">{{p.shortname}}</div>
                                    </a>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>